import { Percent, PositionReward } from "@silo/types";
import { Align, Breakdown } from "./components";
import { asPercent } from "@silo/utils";
import { GLOBAL_CONFIG } from "@silo/config";

interface BreakdownProtectedProps {
  className?: string;
  protectedRewards: PositionReward[];
  align: Align;
  revenueApr: Percent;
}

export function BreakdownProtected({
  className,
  protectedRewards,
  align,
  revenueApr,
}: BreakdownProtectedProps): JSX.Element {
  const hasProtectedRevenue = revenueApr > 0n;

  return (
    <Breakdown.Root className={className} align={align}>
      <Breakdown.Item>
        <Breakdown.ItemValue>--</Breakdown.ItemValue>

        <Breakdown.ItemLabel>deposit APR</Breakdown.ItemLabel>
      </Breakdown.Item>

      {hasProtectedRevenue && (
        <Breakdown.Item>
          <Breakdown.ItemValue>{asPercent(revenueApr)}</Breakdown.ItemValue>

          <Breakdown.ItemLabel>
            revenue APR in {GLOBAL_CONFIG.revenue.rewardTokenSymbol}
          </Breakdown.ItemLabel>
        </Breakdown.Item>
      )}

      {protectedRewards.map((reward) => (
        <Breakdown.DepositRewardItem reward={reward} />
      ))}
    </Breakdown.Root>
  );
}
